import { defineComponent, createApp, ref, computed } from "vue/dist/vue.esm-bundler"

const Component = defineComponent({
  template: "#contact_template",
  setup() {
    const appRoot = document.getElementById("app")
    const name = ref(appRoot?.dataset.name || "")
    const email = ref(appRoot?.dataset.email || "")
    const company = ref(appRoot?.dataset.company || "")
    const message = ref(appRoot?.dataset.message || "")
    const errors = ref({})
    const isSubmitting = ref(false)
    const initialErrors = appRoot?.dataset.fieldErrors
    if (initialErrors) {
      try {
        errors.value = JSON.parse(initialErrors)
      } catch {
        errors.value = {}
      }
    }

    const setError = (key, messageText) => {
      errors.value = { ...errors.value, [key]: messageText }
    }

    const clearError = (key) => {
      const next = { ...errors.value }
      delete next[key]
      errors.value = next
    }

    const validateName = () => {
      if (!name.value.trim()) {
        setError("name", "Name is required.")
        return false
      }
      clearError("name")
      return true
    }

    const validateEmail = () => {
      const value = email.value.trim()
      if (!value) {
        setError("email", "Email is required.")
        return false
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        setError("email", "Enter a valid email address.")
        return false
      }
      clearError("email")
      return true
    }

    const validateMessage = () => {
      if (!message.value.trim()) {
        setError("message", "Message is required.")
        return false
      }
      clearError("message")
      return true
    }

    const handleSubmit = () => {
      validateName()
      validateEmail()
      validateMessage()
      if (isValid.value) {
        isSubmitting.value = true
      }
    }

    const isValid = computed(() => {
      return (
        name.value.trim() &&
        message.value.trim() &&
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())
      )
    })

    return {
      name,
      email,
      company,
      message,
      errors,
      isValid,
      isSubmitting,
      validateName,
      validateEmail,
      validateMessage,
      handleSubmit,
    }
  },
})

createApp(Component).mount("#app")
